import React from 'react'
import { Trans } from '@lingui/macro'

const SkipLink = () => (
  <a href='#main' className='skip-link'>
    <Trans comment='Skip Link'>
      Skip to main content
    </Trans>
  </a>
)

export default SkipLink
